// extracted by mini-css-extract-plugin
export default {"container":"landingPage_container__ptTK1","logo":"landingPage_logo__D93kT","block":"landingPage_block__+0RP-","box":"landingPage_box__9kAbq","img":"landingPage_img__JXabg"};